import { create } from 'zustand';

type LoadingStore = {
	isLoading: boolean;
	onLoading: () => void;
	offLoading: () => void;
};

export const useLoadingStore = create<LoadingStore>((set) => ({
	isLoading: false,
	onLoading: () => set({ isLoading: true }),
	offLoading: () => set({ isLoading: false }),
}));
